import usePeekaboo from './usePeekaboo'

const useExperiment = (key: string) => {
  const { experiments, status } = usePeekaboo()

  for (const experiment of experiments) {
    if (experiment.key === key) {
      return { experiment, status }
    }
  }

  return { experiment: null, status }
}

export default useExperiment
